/**
 * @fileoverview Resolve one legal-page chrome string: consumer `t` → English default — bound from the ONE
 * shared implementation in the React-free `@puffin-core/i18n-bootstrap/strings-kit`, since this file is
 * part of the leaf-only `strings/` subtree the registry imports at app boot.
 *
 * @module @puffin-core/legal-content/strings/resolveString
 */

import { createStringResolver } from '@puffin-core/i18n-bootstrap/strings-kit';

import { LEGAL_CONTENT_EN } from './en.js';

/** @type {(t: Function|undefined|null, key: string, params?: Object) => string|undefined} */
export const resolveString = createStringResolver(LEGAL_CONTENT_EN);

export default resolveString;
